export const HIT_ACTIONPLAN_LIST = 'HIT_ACTIONPLAN_LIST';
export const GET_ACTIONPLAN_LIST = 'GET_ACTIONPLAN_LIST';

export const HIT_ACTIONPLAN_DETAIL = 'HIT_ACTIONPLAN_DETAIL';
export const GET_ACTIONPLAN_DETAIL = 'GET_ACTIONPLAN_DETAIL';
